import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'
import { SidebarTrigger } from '@/components/ui/sidebar'

interface PageHeaderProps {
  children: ReactNode
  className?: string
}

export function PageHeader({ children, className }: PageHeaderProps) {
  return (
    <header className={cn("flex h-14 items-center px-2", className)}>
      {children}
    </header>
  )
}

interface PageHeaderContentProps {
  children: ReactNode
  className?: string
}

export function PageHeaderContent({ children, className }: PageHeaderContentProps) {
  return (
    <div className={cn("flex flex-1 items-center justify-between", className)}>
      {children}
    </div>
  )
}

interface PageHeaderTitleProps {
  children: ReactNode
  className?: string
}

export function PageHeaderTitle({ children, className }: PageHeaderTitleProps) {
  return (
    <h1 className={cn("text-lg font-semibold", className)}>
      {children}
    </h1>
  )
}

interface PageHeaderActionsProps {
  children: ReactNode
  className?: string
}

export function PageHeaderActions({ children, className }: PageHeaderActionsProps) {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      {children}
    </div>
  )
}

interface PageHeaderLeftProps {
  children: ReactNode
  className?: string
}

export function PageHeaderLeft({ children, className }: PageHeaderLeftProps) {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <SidebarTrigger />
      {children}
    </div>
  )
}

interface PageMainProps {
  children: ReactNode
  className?: string
}

export function PageMain({ children, className }: PageMainProps) {
  return (
    <main className={cn(className)}>
      {children}
    </main>
  )
}
